import React, {useEffect, useRef, useState} from 'react';
import auth from "../../../utils/authentication";
import {FaSpinner} from 'react-icons/fa';
import './buttonUser.scss';
import '../buttonMenu/buttonMenu.css';
import {Link, useLocation} from "react-router-dom";
import {SquadflixFriendsApi} from "../../../apis/squadflix-friends/SquadflixFriendsApi";
import {useIntl} from "react-intl";
import {useSelector} from "react-redux";
import users, {LoginHome} from "../../users";
import avatarDefault from "../../../images/avatardefault.png";
import ButtonMenu from "../buttonMenu/buttonMenu";
import useUserPreferences from "../../user-app-config/hooks/use-user-preferences";
import {getTmdbImage} from "../../../utils/consts";
import LinkV2 from "../../shared/link-v2/link-v2";
import {Spinner} from "../../shared";


const ButtonUser = ({className, style}) => {

    const intl = useIntl();

    const [customClaims, setCustomClaims] = useState(null);
    const loginHome = useRef();

    const loading = useSelector(users.selectors.isLoading)
    const darkMode = useSelector(users.selectors.isDarkMode);

    const {userPreferences} = useUserPreferences();
    const location = useLocation();
    const [pendingRequests, setPendingRequests] = useState(0);

    // Fetch incoming friend requests on every location change
    useEffect(() => {
        if (!auth.currentUser) return;
        SquadflixFriendsApi.listFriendRequests()
            .then((response) => {
                if (response.success) {
                    setPendingRequests((response.received ?? []).length);
                }
            })
            .catch(() => { /* silently ignore */ });
    }, [location]);

    useEffect(() => {
        const loadCustomClaims = () => {
            auth.currentUser?.getIdTokenResult().then((idTokenResult) => {
                setCustomClaims(idTokenResult.claims);
            });
        }
        auth.onAuthStateChanged((user) => {
            if (user) {
                loadCustomClaims();
            }
        })
    }, [loading]);

    if (!auth.currentUser) {
        return (<div>
            <ButtonMenu text={intl.formatMessage({id: "users.login.log-in"})} classIcon="fa-solid fa-right-to-bracket"
                        verified={true} className="mb-4" onClick={() => loginHome.current.openModal()}/>
            <ButtonMenu text={intl.formatMessage({id: "users.login.sign-up"})} classIcon={"fa-solid fa-user-plus"}
                        verified={true} className="mb-4" onClick={() => loginHome.current.openModal("signUp")}/>
            <LoginHome ref={loginHome}/>
        </div>)
    }

    if (!customClaims) {
        return (
            <div className="button-user">
                <div className={(darkMode ? "text-light" : "text-dark") + " card button-menu " + className}
                     style={{cursor: "pointer", userSelect: "none", textDecoration: "none", height: 150, ...style}}>
                    <div className="d-flex justify-content-center align-items-center" style={{height: "100%"}}>
                        <Spinner/>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Link to="/my-profile/posts" className="button-user" style={{
            textDecoration: "none",
        }}>
            {pendingRequests > 0 && (
                <span className="button-user__badge">{pendingRequests}</span>
            )}
            <div className={(darkMode ? "text-light" : "text-dark") + " card button-menu " + className}
                 style={{
                     userSelect: "none",
                     textDecoration: "none",
                     position: "relative",
                     overflow: "hidden",
                     ...style
                 }}>
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 0,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundImage: userPreferences?.profileBackground ? `url(${getTmdbImage(userPreferences.profileBackground)})` : undefined,
                }}>
                </div>
                <div className="card-body" style={{
                    width: "100%",
                    height: "100%",
                    zIndex: 1,
                    color: (userPreferences?.profileBackground || darkMode) ? "white" : "black",
                    backgroundColor: userPreferences?.profileBackground ? "rgba(0,0,0,0.38)" : undefined,
                }}>
                    <div className="d-flex flex-row justify-content-between align-items-start"
                         style={{fontSize: "large"}}>
                        <div className="square-container col-4">
                            {!loading && <img alt='User photo url' src={auth.currentUser.photoURL ?? avatarDefault}
                                              className="square-image"/>}
                            {loading &&
                                <div className="d-flex justify-content-center align-items-center"
                                     style={{fontSize: "large"}}>
                                    <FaSpinner className="spinner"/>
                                </div>}
                        </div>
                        <div className="col-8 ps-0">
                            <div style={{fontWeight: "500"}}>
                                <div className="truncated-text">
                                    {auth.currentUser.displayName}
                                </div>
                            </div>
                            <div style={{fontSize: "small", fontWeight: "lighter"}}>
                                #{customClaims.userCode}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-row justify-content-between align-items-center mt-2">
                        {userPreferences?.shortcuts?.map(x => {
                            if (!x.name) {
                                return null;
                            }
                            return (
                                <LinkV2 forceDarkMode="dark" title={x.name} to={x.url} width={40} size="small"
                                        key={x.url}>
                                    <i className={x.icon}></i>
                                </LinkV2>
                            )
                        })}
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default ButtonUser;
